module.exports = __webpack_public_path__ + "static/media/back1.47894cfe.jpg";